module.exports = {"430225100":"霞阳镇","430225101":"沔渡镇","430225102":"十都镇","430225103":"水口镇","430225105":"鹿原镇","430225200":"垄溪乡","430225202":"策源乡","430225203":"下村乡","430225207":"船形乡","430225209":"中村瑶族乡","430225400":"炎陵县大院农场","430225401":"炎陵县桃源洞管理局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430225.json
// module id = 1822
// module chunks = 0